module.exports = __webpack_public_path__ + "img/autosense-mobile-large.2b4d729a.png";